// cart-icon-corrections.js
(function () {
  'use strict';

  var GIFT_WRAP_VARIANT_ID = 45043311050805;
  var SURCHARGE_PRODUCT_HANDLE = 'extended-size-surcharge'; // from the surcharge product's handle

  var excludedVariantIds = new Set([GIFT_WRAP_VARIANT_ID]);
  var surchargeVariantsReady = null; // cached promise so we only fetch once

  function loadSurchargeVariantIds() {
    if (surchargeVariantsReady) return surchargeVariantsReady;

    surchargeVariantsReady = fetch('/products/' + SURCHARGE_PRODUCT_HANDLE + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        return res.json();
      })
      .then(function (product) {
        (product.variants || []).forEach(function (variant) {
          excludedVariantIds.add(variant.id);
        });
      })
      .catch(function (err) {
        console.warn('[cart-icon-corrections] Could not load surcharge product variants, only gift wrap will be excluded:', err);
      });

    return surchargeVariantsReady;
  }

  function getLineVariantId(line) {
    var rawId = line?.id;
    if (typeof rawId !== 'string') return null;

    var variantPart = rawId.split(':')[0];
    var parsed = Number(variantPart);

    return Number.isNaN(parsed) ? null : parsed;
  }

  function getAdjustedItemCount(cart, fallbackCount) {
    var lines =
      cart?.lines?.nodes ??
      cart?.lines?.edges?.map(function (edge) { return edge?.node; }) ??
      cart?.lines;

    if (!Array.isArray(lines)) return fallbackCount;

    return lines.reduce(function (total, line) {
      var variantId = getLineVariantId(line);

      if (variantId !== null && excludedVariantIds.has(variantId)) {
        return total;
      }

      return total + (line?.quantity ?? 0);
    }, 0);
  }

  function correctCartBubbles(itemCount) {
    document.querySelectorAll('cart-icon').forEach(function (cartIcon) {
      var bubbleEl = cartIcon.querySelector('.cart-bubble');
      var countEl = cartIcon.querySelector('.cart-bubble__text-count');
      if (!bubbleEl || !countEl) return;

      countEl.classList.toggle('hidden', itemCount === 0);
      bubbleEl.classList.toggle('visually-hidden', itemCount === 0);
      countEl.textContent = itemCount < 100 ? String(itemCount) : '';
      cartIcon.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);

      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({ value: String(itemCount), timestamp: Date.now() })
      );
    });
  }

  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (!event.promise) return;

    event.promise
      .then(function (result) {
        return loadSurchargeVariantIds().then(function () {
          var cart = result?.cart;
          var detail = result?.detail;
          var rawCount = cart?.totalQuantity ?? detail?.itemCount ?? 0;
          var adjustedCount = getAdjustedItemCount(cart, rawCount);

          if (adjustedCount === rawCount) return;

          requestAnimationFrame(function () {
            correctCartBubbles(adjustedCount);
          });
        });
      })
      .catch(function () {});
  });

  // Kick off the fetch immediately on page load too, so it's
  // already cached by the time the first cart update happens.
  loadSurchargeVariantIds();
})();